import React from 'react';
import { InputAdornment, TextField, type SxProps, type Theme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { obsidianSearchFieldSx } from './obsidianTableTheme';

export interface ObsidianDashboardSearchFieldProps {
    placeholder?: string;
    value?: string;
    onChange: (value: string) => void;
    sx?: SxProps<Theme>;
}

export function ObsidianDashboardSearchField({
    placeholder = 'Search…',
    value,
    onChange,
    sx,
}: ObsidianDashboardSearchFieldProps) {
    return (
        <TextField
            fullWidth
            variant="outlined"
            placeholder={placeholder}
            value={value}
            onChange={e => onChange(e.target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 22, color: 'rgba(173,170,170,0.9)' }} />
                    </InputAdornment>
                ),
            }}
            sx={[obsidianSearchFieldSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
        />
    );
}
